import loadable from '@loadable/component'

export default {
  '/w/questionBank/zhuguan': loadable(() => import('./Home')),
  '/w/questionBank/fashuo': loadable(() => import('./Home')),
  '/w/questionBank': loadable(() => import('./Home')),
  '/w/dataReport': loadable(() => import('./DataReport')), //数据报告
  '/w/reportDetails': loadable(() => import('./DataReportDetail')), //数据报告详情
  '/w/recite': loadable(() => import('./recitationCard')), // 背诵卡片页面
  '/w/beisongrecite': loadable(() => import('./ReciteList')), // 背诵卡片二级页面（背诵列表）
  // '/w/answerAnalysis': loadable(() => import('./AnswerAnalysis')), // 答案解析
  '/w/myWrongQuestion': loadable(() => import('./MyWrongQuestion')), // 我的错题本
  '/w/overYearsOptions': loadable(() => import('./OverYearsOptions')), // 历年真题
  '/w/setUpIntelligence': loadable(() => import('./setUpIntelligence')), //   智能组卷
  '/w/reciteBrushQuestions': loadable(() => import('./ReciteBrushQuestions')), // 背诵卡片-问题详情
  '/w/cardBeisong': loadable(() => import('./CardBeisong')), // 背诵我的卡片
  '/w/myNoteList': loadable(() => import('./MyNoteList')), // 我的笔记（做题笔记）
  '/w/selectedCase': loadable(() => import('./SelectedCases')), // 精选案例
  '/w/shuati/catalog': loadable(() => import('./Catalog')), // 精选案例二级页面 章节练习、
  '/w/sujiRecite': loadable(() => import('./SujiRecite')), // 速记题  速记刷题
  '/w/titleHonour': loadable(() => import('./TitleHonour')), // 荣誉称号说明
  '/w/beiSongDataReport': loadable(() => import('./ReciteDataReport')), // 背诵数据报告
  '/w/searchQuestion': loadable(() => import('./searchQuestion')), // 搜题
  '/w/cardSuji': loadable(() => import('./ShorthandCard')), // 速记卡片
  '/w/sujiQuestion': loadable(() => import('./ShorthandQuestion')), // 速记题
  '/w/sujiReciteInfo': loadable(() => import('./shorthandSecondLevel')), // 速记题二级页面
  // '/w/fvhuibian-old': loadable(() => import('./ElectronicLaw')),
  '/w/fvhuibian': loadable(() => import('./Fvhuibian')),
  // w/my/favorites
  '/w/my/:type': loadable(() => import('./My')),
  '/w/doErrorExercises': loadable(() => import('./DoErrorExercises')), // 我的错题本做题页
  '/w/doErrorAnalysis': loadable(() => import('./DoErrorAnalysis')), // 我的错题本解析
}
